<div class="min-h-screen bg-gray-50">
  <div class="flex h-screen bg-gray-50">
    <app-sidebar></app-sidebar>
    <div class="font flex-1 flex flex-col overflow-hidden lg:ml-0">
      <header class="bg-white shadow-sm border-b border-gray-200 p-4 lg:px-6">
        <div class="flex items-center justify-between">
          <button class="lg:hidden text-gray-500 hover:text-gray-700" (click)="toggleMobileMenu()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-menu w-6 h-6">
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
          </button>
          <div class="flex-1 lg:flex lg:items-center lg:justify-between">
            <h2 class="text-lg font-semibold text-gray-900 ml-4 lg:ml-0">{{'SIDEBAR.DASHBOARD' | translate}}</h2>
          </div>
        </div>
      </header>
      <main class="flex-1 overflow-auto p-4 lg:p-6">
        <div class="space-y-6">
          <div class="bg-gradient-to-r from-blue-600 to-teal-600 rounded-xl p-6 text-white">
            <h1 class="text-2xl font-bold mb-2">{{'CANDIDATES.WELCOME_BACK' | translate}}</h1>
            <p class="text-blue-100">{{'CANDIDATES.HERE_WHAT_HAPPENING_WITH_YOUR_HIRING_PROCESS_TODAY' | translate}}</p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm font-medium text-gray-600">{{'CANDIDATES.TOTAL_APPLICATIONS' | translate}}</p>
                  <p class="text-2xl font-bold text-gray-900 mt-1">{{statistics?.applicationsThisMonthCount || 0}}</p>
                </div>
                <div class="bg-blue-500 p-3 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-users w-6 h-6 text-white">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </div>
              </div>
              <div class="flex items-center mt-4">
                <span class="text-sm font-medium"
                      [ngClass]="{
                        'text-green-600': (statistics?.applicationsLastMonthCompared || 0) >= 0,
                        'text-red-600': (statistics?.applicationsLastMonthCompared || 0) < 0
                      }">
                  {{formatComparison(statistics?.applicationsLastMonthCompared || 0)}}
                </span>
                <span class="text-sm text-gray-500 ml-2">{{'CANDIDATES.VS_LAST_MONTH' | translate}}</span>
              </div>
            </div>

            <!-- In Screening Card -->
            <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm font-medium text-gray-600">{{'CANDIDATES.IN_SCREENING' | translate}}</p>
                  <p class="text-2xl font-bold text-gray-900 mt-1">{{statistics?.inScreeningThisMonthCount || 0}}</p>
                </div>
                <div class="bg-yellow-500 p-3 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-clock w-6 h-6 text-white">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                </div>
              </div>
              <div class="flex items-center mt-4">
                <span class="text-sm font-medium"
                      [ngClass]="{
                        'text-green-600': (statistics?.inScreeningLastMonthCompared || 0) >= 0,
                        'text-red-600': (statistics?.inScreeningLastMonthCompared || 0) < 0
                      }">
                  {{formatComparison(statistics?.inScreeningLastMonthCompared || 0)}}
                </span>
                <span class="text-sm text-gray-500 ml-2">{{'CANDIDATES.VS_LAST_MONTH' | translate}}</span>
              </div>
            </div>

            <!-- Hired This Month Card -->
            <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm font-medium text-gray-600">{{'CANDIDATES.HIRED_THIS_MONTH' | translate}}</p>
                  <p class="text-2xl font-bold text-gray-900 mt-1">{{statistics?.hiredThisMonthCount || 0}}</p>
                </div>
                <div class="bg-green-500 p-3 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-user-check w-6 h-6 text-white">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <polyline points="16 11 18 13 22 9"></polyline>
                  </svg>
                </div>
              </div>
              <div class="flex items-center mt-4">
                <span class="text-sm font-medium"
                      [ngClass]="{
                        'text-green-600': (statistics?.hiredLastMonthCompared || 0) >= 0,
                        'text-red-600': (statistics?.hiredLastMonthCompared || 0) < 0
                      }">
                  {{formatComparison(statistics?.hiredLastMonthCompared || 0)}}
                </span>
                <span class="text-sm text-gray-500 ml-2">{{'CANDIDATES.VS_LAST_MONTH' | translate}}</span>
              </div>
            </div>

            <!-- Success Rate Card -->
            <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm font-medium text-gray-600">{{'CANDIDATES.SUCCESS_RATE' | translate}}</p>
                  <p class="text-2xl font-bold text-gray-900 mt-1">{{statistics?.successRateThisMonth || 0}}%</p>
                </div>
                <div class="bg-purple-500 p-3 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-trending-up w-6 h-6 text-white">
                    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                    <polyline points="16 7 22 7 22 13"></polyline>
                  </svg>
                </div>
              </div>
              <div class="flex items-center mt-4">
                <span class="text-sm font-medium"
                      [ngClass]="{
                        'text-green-600': (statistics?.successRateLastMonthCompared || 0) >= 0,
                        'text-red-600': (statistics?.successRateLastMonthCompared || 0) < 0
                      }">
                  {{formatComparison(statistics?.successRateLastMonthCompared || 0)}}
                </span>
                <span class="text-sm text-gray-500 ml-2">{{'CANDIDATES.VS_LAST_MONTH' | translate}}</span>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">{{'CANDIDATES.RECENT_APPLICATIONS' | translate}}</h3>
              <div class="space-y-4">

                <div *ngIf="recentApplications.length === 0" class="text-center py-8">
                  <p class="text-gray-500 text-sm">{{'CANDIDATES.NO_RECENT_APPLICATIONS' | translate}}</p>
                </div>

                <div *ngFor="let candidate of recentApplications; trackBy: trackByFn"
                     class="flex items-center space-x-4 p-3 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer" [routerLink]="['/candidates', candidate.id]">
                  <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <span class="text-blue-600 font-semibold">{{candidate.firstName.charAt(0)}}</span>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-gray-900">{{candidate.firstName}} {{candidate.lastName}}</p>
                    <p class="text-xs text-gray-500">{{candidate.emailAddress}}</p>
                  </div>
                  <div class="text-right">
                    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                          [ngClass]="getStatusClass(candidate.status?.name)">
                      {{candidate.status.name | titlecase}}
                    </span>
                    <p class="text-xs text-gray-500 mt-1">{{formatDate(candidate.created)}}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">{{'CANDIDATES.QUICK_ACTIONS' | translate}}</h3>
              <div class="space-y-3">
                <button class="w-full flex items-center p-4 text-left bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors group"  [routerLink]="'/forms'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-file-text w-5 h-5 text-blue-600 mr-3">
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                    <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                    <path d="M10 9H8"></path>
                    <path d="M16 13H8"></path>
                    <path d="M16 17H8"></path>
                  </svg>
                  <div>
                    <p class="text-sm font-medium text-gray-900">{{ 'CANDIDATES.CREATE_NEW_JOB_FORM' | translate }}</p>
                    <p class="text-xs text-gray-500">{{ 'CANDIDATES.SET_UP_FORMS_FOR_DIFFERENT_POSITIONS' | translate }}</p>
                  </div>
                </button>
                <button class="w-full flex items-center p-4 text-left bg-teal-50 hover:bg-teal-100 rounded-lg transition-colors group"  [routerLink]="'/candidates'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-users w-5 h-5 text-teal-600 mr-3">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                  <div>
                    <p class="text-sm font-medium text-gray-900">{{ 'CANDIDATES.REVIEW_CANDIDATES' | translate }}</p>
                    <p class="text-xs text-gray-500">{{ 'CANDIDATES.CHECK_PENDING_APPLICATIONS' | translate }}</p>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</div>

<!-- Video Popup -->
<div *ngIf="showVideoPopup" class="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg shadow-lg max-w-3xl w-full relative p-5">
    <button (click)="closePopup()" class="absolute top-1 right-2 text-gray-600 hover:text-gray-900 text-xl font-bold">&times;</button>
    <div class="wistia_responsive_padding relative rounded-[10px] overflow-hidden" style="padding-bottom: 56.25%; height: 0;">
      <div class="wistia_responsive_wrapper h-full w-full top-0 left-0 absolute">
        <div class="wistia_embed wistia_async_k3lliaxdjl h-full w-full relative">&nbsp;</div>
      </div>
    </div>
  </div>
</div>

